import { render } from "./DiceBox.vue?vue&type=template&id=0edc2ce5&scoped=true"
import script from "./DiceBox.vue?vue&type=script&lang=js"
export * from "./DiceBox.vue?vue&type=script&lang=js"

import "./DiceBox.vue?vue&type=style&index=0&id=0edc2ce5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edc2ce5"]])

export default __exports__